import { Component, OnInit,Inject } from '@angular/core';
import { Utilities } from 'src/app/shared/utility-services.service';
import { FormGroup } from '@angular/forms';
import { BackendService } from 'src/app/shared/backend.service';
import { NotificationService } from 'src/app/notification.service';
import { AuthService } from 'src/app/shared/auth.service';

import { AlertmessageService } from 'src/app/shared/alertmessage.service';
import { Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Location } from '@angular/common';
import CONFIG from 'src/app/config';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent extends Utilities implements OnInit {

  passwordConfirmed: boolean = true;
  submitted: boolean = false;
  updatedProfile: FormGroup;
  Submitted:any;

  constructor(
    public backendService: BackendService,
    public notificationService: NotificationService,
    public authService: AuthService,
    public location: Location,
    public dialog: MatDialog,
    public alert:AlertmessageService,
    public _router:Router,
    @Inject(MAT_DIALOG_DATA) public data: any) 
   { super(location, notificationService, authService, backendService)};

  ngOnInit() {
    //console.log(this.data);
    this.Submitted=this.data.daPendindACCID;
    //console.log(this.Submitted);
  }
  no() {
    this.dialog.closeAll();
    this._router.navigate(['/dashboard/viewimportaudit']);
    //console.log(updatedProfile[updatedProfile] , this.passwordConfirmed);
  }
  accept() {
    
    this.btnDelete(this.data);
    this.dialog.closeAll();
    
  }
  btnDelete(Record)
  {
    //console.log(Record);

    this.backendService.postData(Record,`${CONFIG.viewSubmissionDeleteApiUrlBase}/${this.Submitted}`)
    .subscribe(response => {
      if (response) {[]
        //this.setForm();
        this.alert.openConfirmationDialogLong1(response['msg']);;
       
       // this.getbankIdDropdown();
      // this.getSubmissions();
      //this.loadingData = true;
      //this.filterbyStatus();
     //this.refresh()
      }
      else {
        this.alert.openConfirmationDialogLong(response['msg']);;
        //this.getSubmissions();
       // this.loadingData = true;
      // this.refresh()
      }

    });
  }

}
